"use client";

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function ScrollSlideLeft({ children }: { children: React.ReactNode }) {
    const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }} // Start from the left
            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} // Move to normal position
            transition={{ duration: 0.8, ease: "easeOut" }}
        >
            {children}
        </motion.div>
    );
}
